import React from "react";

const Card3 = ({data}) => {


  return (
    <div className={`min-h-screen w-full overflow-hidden ${data?.selectedTheme?.swatches?.primary.bg}`}>
      {/* Blurred background */}
      <div className="absolute top-0 left-0 h-[345px] w-full overflow-hidden">
        <img
          src={data?.photo?.url}
          alt={data?.displayName}
          className="h-full w-full scale-110 object-cover blur-xl"
        />

        <div className="absolute inset-0 bg-black/10" />
      </div>

      {/* Main content */}
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[736px] flex-col items-center">
        
        {/* White Card */}
        <div className="relative mt-[268px] w-[82%] rounded-[48px] bg-[#f7f7f7] px-6 pb-8 pt-[135px] text-center shadow-sm">
          
          {/* Profile image */}
          <div className="absolute -top-[110px] left-1/2 h-[220px] w-[220px] -translate-x-1/2 overflow-hidden rounded-[80px]">
            <img
              src={data?.photo}
              alt={data?.displayName}
              className="h-full w-full object-cover"
            />
          </div>

          {/* Name */}
          <h3 className="text-[22px] font-medium leading-tight tracking-[1px] text-[#171a20]">
            {data?.displayName}
          </h3>

          {/* Subtitle */}
          <h4 className="mt-4 text-[18px] font-medium text-[#171a20]">
            {data.tagline}
          </h4>

          {/* Line */}
          <div className="mx-auto mt-4 h-[2px] w-[135px] bg-[#222222]" />

          {/* Description */}
          <p className="mx-auto mt-11 max-w-[460px] text-[14px] leading-[1.35] text-[#292d35]">
           {data?.bio}
          </p>
        </div>

        {/* Buttons */}
        <div className="mt-4 flex w-[63%] flex-col gap-3">
          {data.filteredLinks?.map((link) => (
        
            <a
              key={link.id}
              target="_blank"
              href={data?.platformLinks?.[link.id]}
              className={`flex h-[40px] items-center justify-center rounded-full ${data?.selectedTheme?.swatches?.secondary.bg}  text-[14px] font-medium tracking-[6px] text-white transition duration-300 hover:scale-[1.02] hover:shadow-lg`}
            >
              {link.title}
            </a>
          ))}
        </div>

        {/* Username */}
        <div className="mt-14 pb-16 text-[24px] font-light tracking-[1px] text-white">
          @{data?.username}
        </div>
      </div>
    </div>
  );
};

export default Card3;